import axios from "axios";

/**
 * Base API class to handle all requests to the API
 *
 * @example
 * class MyApi extends BaseApi {
 *  constructor() {
 *   super("my_resource"); // example: "proposal-tool"
 * }
 * }
 */
class BaseApi {
  constructor(resource) {
    this.resource = resource;
    this.base_url = "https://dev.iondeveloper.com/api/proposal";
    this.api_key = process.env.REACT_APP_API_KEY;

    // This is a hack for the sales api until we can get everything in one server.
    if (resource === "docusign") {
      this.base_url = process.env.REACT_APP_SALES_API_URL;
    }
/*
    if (
      window.location.hostname.includes("localhost") ||
      window.location.hostname.includes("staging")
    ) {
      this.base_url = "https://dev.iondeveloper.com/api/proposal-dev";
    }
    */ 
  }

  /**
   * Get the URL for the API
   *
   * @returns {String} The URL for the API
   */
  getUrl() {
    return this.#generateURL();
  }

  /**
   * Base request for our API
   *
   * @note You can pass in an options object to override the resource
   * @example
   * this.request({
   *  method: "get_disclosures",
   *  options: {
   *   override: {
   *    resource: "sungage",
   *  },
   * },
   */
  async request({ method, options, ...data }) {
    if (!this.resource) {
      throw new Error("resource is not defined");
    }

    const url = this.#generateURL(options);
    const res = await axios.post(url, { method, ...data });

    return res.data;
  }

  #generateURL = (options) => {
    return `${this.base_url}/${
      options?.override?.resource ?? this.resource
    }/?api_key=${this.api_key}`;
  };
}

export default BaseApi;
